import { FC, useState } from 'react';
import {
  Table,
  TPaginationOnChangeArgs,
} from '@spotted-zebra-uk/ui-components';
import styles from './BehaviourSoftSkillTable.module.scss';

interface IBehaviourSoftSkillTable {
  softSkills: {
    id: string;
    name: string;
    companyOwner: string;
  }[];
}
const BehaviourSoftSkillTable: FC<IBehaviourSoftSkillTable> = ({
  softSkills,
}) => {
  const [firstRowIndex, setFirstRowIndex] = useState(0);
  const [currPageSize, setCurrPageSize] = useState(10);
  const [page, setPage] = useState(1);

  const handlePaginationChange = ({
    page,
    pageSize,
  }: TPaginationOnChangeArgs) => {
    if (pageSize !== currPageSize) {
      setCurrPageSize(pageSize);
    }
    setFirstRowIndex(pageSize * (page - 1));
    setPage(page);
  };

  const paginatedRows = softSkills?.slice(
    firstRowIndex,
    firstRowIndex + currPageSize
  );

  return (
    <Table
      headerData={[
        { key: 'id', header: 'ID' },
        { key: 'name', header: 'Name' },
        { key: 'companyOwner', header: 'Company owner' },
      ]}
      hasPagination
      rowData={paginatedRows}
      title="Soft Skills"
      pagination={{
        currentPageSize: currPageSize,
        onChange: handlePaginationChange,
        totalNumberOfItems: softSkills.length,
        page,
      }}
      className={styles.softSkillTable}
    />
  );
};

export default BehaviourSoftSkillTable;
